// @ts-nocheck
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

import { FeatureCardsSkeleton } from "components/Loader/HomeSkeletonLoader/FeatureCardsSkeleton";
import { FeaturedCards } from "../HomeFeatured/FeaturedCards";

// Icons
import { SvgButtonArrowLeft } from "assets/icons/js/SvgButtonArrowLeft";
import { SvgButtonArrowRight } from "assets/icons/js/SvgButtonArrowRight";

// helpers
import getImg from "helpers/getCloudinaryImage";
import parseHTML from "helpers/parseHTML";

// customHooks
import { useMediaQuery } from "customHooks/useMediaQuery";

//style
import "components/Home/HomeNewHomes/style.scss";
import { HomeNewCard } from "components/NewHomePage/HomeNewCard";

// const HomeRecomendation = ({ listingID }) => {
// 	const [scrollX, setscrollX] = useState(0);
// 	const [scrollEnd, setscrolEnd] = useState(false);

// 	const listRef = useRef(null);

// 	const width = useMediaQuery();

// 	const [recomVilla, setRecomVilla] = useState([]);
// 	const [loading, setLoading] = useState(false);
// 	const [tabs, setTabs] = useState([]);
// 	const [selectTab, setSelectTab] = useState("");

// 	const [filterVilla, setFilterVilla] = useState([]);

// 	const slide = (shift) => {
// 		listRef.current.scrollLeft += shift;
// 		setscrollX(scrollX + shift);

// 		if (
// 			Math.floor(listRef.current.scrollWidth - listRef.current.scrollLeft) <=
// 			listRef.current.offsetWidth
// 		) {
// 			setscrolEnd(true);
// 		} else {
// 			setscrolEnd(false);
// 		}
// 	};

// 	// check the scrollEnd
// 	const scrollCheck = () => {
// 		setscrollX(listRef.current.scrollLeft);
// 		if (
// 			Math.floor(listRef.current.scrollWidth - listRef.current.scrollLeft) <=
// 			listRef.current.offsetWidth
// 		) {
// 			setscrolEnd(true);
// 		} else {
// 			setscrolEnd(false);
// 		}
// 	};

// 	const getRecommendation = async () => {
// 		setLoading(false);
// 		// const { data } = await axios.get(
// 		// 	"https://ecapi.saffronstays.com/get/user/ip-addr",
// 		// );

// 		const res = await axios.get(
// 			"https://go.saffronstays.com/api/recombee?ip=12&q=" + listingID,
// 		);
// 		setLoading(true);
// 		if (res.data.data.length > 0) {
// 			setTabs(res.data.amens ? res.data.amens : []);
// 			setRecomVilla(res.data?.data);
// 			setSelectTab(res.data.amens ? res.data.amens[0] : null);

// 			if (!res.data.amens) {
// 				setSelectTab(Object.values(res.data.data[0]?.suitables)[0]);
// 				// setTabs(Object.values(res.data.data[0]?.suitables)[0]);
// 			}

// 			filterVillaByTab();
// 		}
// 	};

// 	const filterVillaByTab = () => {
// 		const temp = recomVilla.filter((e) => {
// 			return Object.values(e.suitables).includes(selectTab);
// 		});
// 		setFilterVilla([...temp]);
// 	};

// 	useEffect(() => {
// 		getRecommendation();
// 	}, []);

// 	useEffect(() => {
// 		if (recomVilla.length > 0) {
// 			filterVillaByTab();
// 		}
// 	}, [selectTab]);

// 	return (
// 		<section className="recomended-menu" style={{ marginBottom: "40px" }}>
// 			{selectTab && (
// 				<div className="recomended-menu-container">
// 					<div className="recomended-header">
// 						<div className="recomended-title">
// 							<h2 className="featured-title">{"We also suggest"}</h2>
// 							{tabs.length !== 0 && (
// 								<div
// 									className="recomended-header-title "
// 									style={{
// 										marginTop: "1rem",
// 									}}
// 								>
// 									{tabs.map((ele, index) => {
// 										return (
// 											<span
// 												key={index}
// 												className={ele === selectTab ? "active" : ""}
// 												onClick={() => {
// 													setSelectTab(ele);
// 												}}
// 											>
// 												<p className={ele === selectTab ? "active-tab" : ""}>
// 													{ele}
// 												</p>
// 											</span>
// 										);
// 									})}
// 								</div>
// 							)}
// 						</div>
// 						<div className="recomended-button">
// 							<span className="button-one" onClick={() => slide(-500)}>
// 								{scrollX === 0 ? (
// 									<SvgButtonArrowLeft
// 										height={width <= "500" ? 22 : 34}
// 										width={width <= "500" ? 22 : 34}
// 										style={{ cursor: "pointer" }}
// 									/>
// 								) : (
// 									<SvgButtonArrowRight
// 										height={width <= "500" ? 22 : 34}
// 										width={width <= "500" ? 22 : 34}
// 										style={{ transform: "rotate(180deg)", cursor: "pointer" }}
// 									/>
// 								)}
// 							</span>
// 							<span className="button-two" onClick={() => slide(500)}>
// 								{!scrollEnd ? (
// 									<SvgButtonArrowRight
// 										height={width <= "500" ? 22 : 34}
// 										width={width <= "500" ? 22 : 34}
// 										style={{ cursor: "pointer" }}
// 									/>
// 								) : (
// 									<SvgButtonArrowLeft
// 										height={width <= "500" ? 22 : 34}
// 										width={width <= "500" ? 22 : 34}
// 										style={{ transform: "rotate(180deg)", cursor: "pointer" }}
// 									/>
// 								)}
// 							</span>
// 						</div>
// 					</div>
// 					{/* Cards Container */}
// 					<div
// 						className="main_container-listing"
// 						ref={listRef}
// 						onScroll={scrollCheck}
// 					>
// 						{!loading && (
// 							<div
// 								style={{
// 									height: "500px",
// 									width: "100%",
// 									overflowY: "hidden",
// 									display: "flex",
// 									gap: "20px",
// 								}}
// 							>
// 								{[1, 2, 3]?.map((item) => (
// 									<FeatureCardsSkeleton key={Math.random() * 1000} />
// 								))}
// 							</div>
// 						)}
// 						{filterVilla.map((item: any) => {
// 							const imgNewArray = item.image_list?.map((v: any) => {
// 								return getImg({
// 									id: v,
// 									version: "1636374075",
// 									quality: "62",
// 									width: "800",
// 									height: "460",
// 								});
// 							});
// 							const amen = Object.values(item?.amenities);
// 							const sui = Object.values(item?.suitables);

// 							const location = item.city + ", " + item.state;

// 							const benefits = [...amen, ...sui];

// 							const type =
// 								item?.type_flag === "EV"
// 									? "Entire Home"
// 									: item?.type_flag === "MV"
// 									? "Separate Villas"
// 									: item?.type_flag === "SR"
// 									? "Single Room"
// 									: item?.type_flag === "MR"
// 									? "Separate Rooms"
// 									: item?.type_flag === "EV-MR"
// 									? "Entire Home"
// 									: "";

// 							return (
// 								<HomeNewCard
// 									key={item?.id}
// 									// @ts-ignore
// 									id={item?.id}
// 									title={parseHTML(item?.file_refernce?.split(" - ")[0])}
// 									location={location}
// 									img={imgNewArray}
// 									benefits={benefits}
// 									rating={item?.rating}
// 									reviews={item?.reviews}
// 									price={item?.price}
// 									signature={item?.signature === "Signature" ? 1 : 0}
// 									noOfBedrooms={item?.bedrooms}
// 									capacity={item?.total_guest}
// 									type={type}
// 									inCollection={item?.inDreamList}
// 									available={item?.availability}
// 									hidePrice={false}
// 									seoURL={item?.seo_url}
// 									newHome={item?.new_home ? true : false}
// 									prevLocation="New Homes"
// 								/>
// 							);
// 						})}
// 					</div>
// 				</div>
// 			)}
// 		</section>
// 	);
// };

const HomeRecomendation = ({ listingID }) => {
	return null;
};

export default HomeRecomendation;
